import { AUTH_TOKEN_KEY } from '@/lib/constants/authentication'

const clearAuthToken = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY)
}

export default clearAuthToken
